import actions from './actions';
import mutations from './mutations';

const users = {
    namespaced: true,
    state: {
        drivers: initUsersObj(),
        operators: initUsersObj(),
        clients: {
            items: [],
            pagination: {
                page: 1,
                totalPages: 1,
                count: 0
            },
            filters: {
                query: null
            }
        }
    },
    mutations,
    actions
};

function initUsersObj() {
    return ({
        items: [],
        pagination: {
            page: 1,
            totalPages: 1,
            count: 0
        },
        filters: {
            query: '',
            filterBy: null,
            startDate: null,
            endDate: null,
            brandId: null,
            roleName: null,
            commissionId: null
        }
    });
}

export default users;
